const FenceTypesElPaso = () => {
  const fenceTypes = [
    {
      image: 'https://public.readdy.ai/ai/img_res/00769d8d33373ac2797b2e78eeb5e77c.jpg',
      title: 'Wood Fencing',
      description: 'Classic cedar and pine fencing offering natural beauty, privacy, and customizable designs for El Paso homes.',
      features: ['Cedar & Pine Options', 'Privacy & Picket Styles', 'Custom Heights', 'Natural Aesthetic']
    },
    {
      image: 'https://readdy.ai/api/search-image?query=White%20vinyl%20privacy%20fence%20with%20clean%20modern%20design%20in%20sunny%20residential%20setting%2C%20low%20maintenance%20material%2C%20smooth%20finish%2C%20simple%20background%20showcasing%20durable%20PVC%20fencing%20installation%20quality&width=800&height=600&seq=fence-type-vinyl-001&orientation=landscape',
      title: 'Vinyl Fencing',
      description: 'Low-maintenance vinyl fencing that withstands El Paso weather without warping, rotting, or requiring paint.',
      features: ['Maintenance-Free', 'Weather Resistant', 'Multiple Colors', '20+ Year Lifespan']
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Galvanized%20chain%20link%20fence%20with%20metal%20posts%20in%20commercial%20property%20setting%2C%20silver%20metallic%20finish%2C%20durable%20security%20fencing%2C%20simple%20background%20highlighting%20industrial%20strength%20and%20practical%20design&width=800&height=600&seq=fence-type-chainlink-001&orientation=landscape',
      title: 'Chain Link Fencing',
      description: 'Affordable and durable chain link fencing perfect for security, pet containment, and commercial properties.',
      features: ['Cost-Effective', 'High Durability', 'Security Options', 'Quick Installation']
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Elegant%20black%20wrought%20iron%20decorative%20fence%20with%20ornamental%20scrollwork%20and%20finials%2C%20classic%20design%2C%20upscale%20residential%20property%2C%20simple%20background%20showcasing%20premium%20metalwork%20craftsmanship%20and%20timeless%20style&width=800&height=600&seq=fence-type-iron-001&orientation=landscape',
      title: 'Wrought Iron Fencing',
      description: 'Elegant ornamental iron fencing combining security with sophisticated curb appeal for upscale properties.',
      features: ['Premium Appearance', 'Maximum Security', 'Custom Designs', 'Long-Lasting']
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Modern%20aluminum%20fence%20with%20vertical%20pickets%20in%20charcoal%20color%2C%20contemporary%20residential%20design%2C%20rust-proof%20material%2C%20simple%20background%20highlighting%20sleek%20metal%20fencing%20and%20clean%20architectural%20lines&width=800&height=600&seq=fence-type-aluminum-001&orientation=landscape',
      title: 'Aluminum Fencing',
      description: 'Rust-proof aluminum fencing offering the look of wrought iron with lower maintenance and cost.',
      features: ['Rust-Proof', 'Lightweight', 'Multiple Styles', 'Easy Maintenance']
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Composite%20fence%20panels%20in%20rich%20brown%20color%20combining%20wood%20appearance%20with%20synthetic%20durability%2C%20modern%20eco-friendly%20fencing%2C%20simple%20background%20showcasing%20sustainable%20material%20and%20contemporary%20design&width=800&height=600&seq=fence-type-composite-001&orientation=landscape',
      title: 'Composite Fencing',
      description: 'Eco-friendly composite fencing combining wood aesthetics with synthetic durability and minimal upkeep.',
      features: ['Eco-Friendly', 'Wood Appearance', 'No Rot or Splinters', 'Minimal Maintenance']
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Popular Fence Types in El Paso
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Choose from a variety of fencing materials and styles designed to withstand El Paso's climate while enhancing your property's security and appearance.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {fenceTypes.map((type, index) => (
            <div
              key={index}
              className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow"
            >
              <div className="w-full h-64">
                <img
                  src={type.image}
                  alt={type.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {type.title}
                </h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {type.description}
                </p>
                <ul className="space-y-2">
                  {type.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm text-gray-700">
                      <i className="ri-check-line text-orange-600 mr-2"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FenceTypesElPaso;
